import { UpgradePlanCompactCta } from './UpgradePlanCompactCta'

/** Top-bar upgrade CTA for FREE / STANDARD users (not VIP, not legacy). */
export function FreePlanUpgradeTopbarCta() {
  return <UpgradePlanCompactCta variant="topbar" />
}
